import { Link } from 'react-router'

/*
 * 404. De bestaande site heeft geen 404-pagina; deze volgt de vormgeving van de
 * andere contentpagina's. De statische host levert het bestand met status 404
 * terug — dat is geregeld in staticwebapp.config.json, niet hier; een statische
 * pagina kan zelf geen statuscode zetten.
 */
export default function NietGevonden() {
  return (
    <>
      <div className="page-head">
        <div className="wrap">
          <span className="eyebrow">Pagina niet gevonden</span>
          <h1>Deze pagina bestaat niet</h1>
          <p className="lede">
            De pagina die u zocht is verplaatst of bestaat niet meer. Via de
            homepage vindt u alles terug.
          </p>
        </div>
      </div>
      <section className="section" style={{ paddingTop: '36px' }}>
        <div className="wrap">
          <Link to="/" className="btn btn--primary btn--big">
            Naar de homepage
          </Link>
        </div>
      </section>
    </>
  )
}
